// extracted by mini-css-extract-plugin
module.exports = {"downloadButton":"ProtocolLink_downloadButton__2m6RB","documentUrl":"ProtocolLink_documentUrl__2z-94","downloadButton_disabled":"ProtocolLink_downloadButton_disabled__26T-l"};